// extracted by mini-css-extract-plugin
export var counter = "CounterGroup-module--counter--997df";
export var counterGroup = "CounterGroup-module--counterGroup--f3d95";
export var fadeInAnimation = "CounterGroup-module--fadeInAnimation--698bf";
export var title = "CounterGroup-module--title--3978d";